import { OptionType } from '@evinced-private/ui-common';

import { TestRowSharedType } from '../../helpers/types';
import { RequestPayload } from '../types/PayloadTypes';

/**
 * Creates a request payload for a specific row
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createRowPayload = (runId: string, changes: any[]): RequestPayload => {
	return {
		scope: {
			conditions: [{ field: 'run_id', value: runId }],
			entityName: 'all'
		},
		changes
	};
};

/**
 * Builds payloads for all rows that have additions
 */
export const buildPayloadsForRows = (
	testRows: TestRowSharedType[],
	rowIdToAdditionsMap: Map<string, Array<{ labelType: OptionType; value: OptionType }>>,
	buildChanges: (
		row: TestRowSharedType,
		additions: Array<{ labelType: OptionType; value: OptionType }>
	) => unknown[]
): RequestPayload[] => {
	const updates: RequestPayload[] = [];

	for (const row of testRows) {
		const rowId = row.runId || row.sessionId;
		if (!rowId) {
			continue;
		}

		const rowAdditions = rowIdToAdditionsMap.get(rowId);
		if (!rowAdditions || rowAdditions.length === 0) {
			continue;
		}

		const changes = buildChanges(row, rowAdditions);

		if (changes.length > 0) {
			updates.push(createRowPayload(rowId, changes));
		}
	}

	return updates;
};
